export const FETCH_KYC_JOURNEY_REQUEST = 'FETCH_KYC_JOURNEY_REQUEST';
export const FETCH_KYC_JOURNEY_SUCCESS = 'FETCH_KYC_JOURNEY_SUCCESS';
export const FETCH_KYC_JOURNEY_FAILURE = 'FETCH_KYC_JOURNEY_FAILURE';
export const FETCH_BANK_JOURNEY_REQUEST = 'FETCH_BANK_JOURNEY_REQUEST';
export const FETCH_BANK_JOURNEY_SUCCESS = 'FETCH_BANK_JOURNEY_SUCCESS';
export const FETCH_BANK_JOURNEY_FAILURE = 'FETCH_BANK_JOURNEY_FAILURE';
export const FETCH_TXN_JOURNEY_REQUEST = 'FETCH_TXN_JOURNEY_REQUEST';
export const FETCH_TXN_JOURNEY_SUCCESS = 'FETCH_TXN_JOURNEY_SUCCESS';
export const FETCH_TXN_JOURNEY_FAILURE = 'FETCH_TXN_JOURNEY_FAILURE';
